module.exports = __webpack_public_path__ + "img/Niehaus@1x.b4691771.png";